export default "__VITE_ASSET__a13d1e8c__"